/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import ReportProblemIcon from "@material-ui/icons/ReportProblem";
import { useI18n } from "hooks/i18n/i18n";
import { Fragment } from "react";

import {
  continuePaymentButtonStyle,
  paymentAlertContentStyle,
  paymentAlertIconStyle,
  paymentAlertTextBoldStyle,
  paymentAlertTextStyle,
  paymentAlertWrapperStyle,
} from "./styles";

import type { FC } from "react";

type Props = {
  isPayPalPending: boolean;
  onContinuePayment: () => void;
};

export const PaymentAlert: FC<Props> = (props) => {
  const { isPayPalPending, onContinuePayment } = props;

  const { t } = useI18n();

  const contents = isPayPalPending ? (
    <div css={paymentAlertTextStyle}>
      <p css={paymentAlertTextBoldStyle}>
        {t("settlementHistory.paypalPendingReview")}
      </p>
    </div>
  ) : (
    <Fragment>
      <div css={paymentAlertContentStyle}>
        <p css={paymentAlertTextBoldStyle}>
          {t("settlementHistory.paymentProcedureRequest")}
        </p>
        <p>{t("settlementHistory.necessaryProceduresRemain")}</p>
      </div>
      <button
        css={continuePaymentButtonStyle}
        onClick={onContinuePayment}
        aria-label={t("settlementHistory.continueToSettle")}
      >
        {t("settlementHistory.continueToSettle")}
      </button>
    </Fragment>
  );

  return (
    <div css={paymentAlertWrapperStyle}>
      <div css={paymentAlertIconStyle}>
        <ReportProblemIcon htmlColor="#975a16" />
      </div>
      {contents}
    </div>
  );
};
